import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import {
  CookieConsentService,
  CookieConsentState,
} from '@app/core/services/internal/cookie-consent.service';
import { NgIf } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-cookie-consent',
    templateUrl: './cookie-consent.component.html',
    styleUrls: ['./cookie-consent.component.scss'],
    imports: [
        NgIf,
        RouterLink,
    ],
})
export class CookieConsentComponent implements OnInit, OnDestroy {
  visible = false;
  private sub?: Subscription;

  constructor(private consent: CookieConsentService) {}

  ngOnInit(): void {
    this.sub = this.consent.state$.subscribe((state: CookieConsentState) => {
      this.visible = state === 'pending';
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  accept(): void {
    this.consent.accept();
  }

  reject(): void {
    this.consent.reject();
  }
}
